<template>
<b-tab lazy title-item-class="mb-1" class="p-0" :title-link-class="{ 'bg-danger': hasErrors, 'bg-warning': isDirty }">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> Maternity
    </template>
    <maternity-base />
</b-tab>
</template>
<script>
import TabExtension from "./TabExtension"
import MaternityBase from "@/core/components/maternity/MaternityBase"

export default TabExtension.extend({
    name: "maternity",
    components: {
        'maternity-base': MaternityBase
    }
})
</script>
